import Illustration from '../components/Illustration/Illustration';

const Binoculars = Illustration(
  'binoculars',
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M89.588 18.997S99.878 21.012 101 35.159c6.622-8.167 1.154-17.378-11.41-16.162Zm30.577 8.72a49088.908 49088.908 0 0 0-22.402 17.714c3.441-11.752-5.328-31.434-18.863-23.93-8.83 5.397-17.66 10.805-26.489 16.226L25.955 53.934C9.895 62.1.75 73.08.523 93.86c-.841 29.084 26.36 51.588 45.59 26.234 5.975-8.269 11.943-16.542 17.903-24.818-.41 32.568 33.532 50.871 48.912 19.056 6.931-14.386 13.87-28.766 20.815-43.14 1.311-3.223 2.933-6.291 4.542-9.337 3.448-6.525 6.84-12.945 7.009-20.554-.108-16.506-13.449-26.125-25.129-13.584Zm-92.97 93.368c-10.785 0-19.5-12.187-19.5-27.224 0-15.036 8.736-27.223 19.5-27.223s19.49 12.187 19.49 27.223c0 15.037-8.726 27.224-19.49 27.224Zm63.46 0c-10.784 0-19.488-12.187-19.488-27.224 0-15.036 8.725-27.223 19.489-27.223 10.764 0 19.5 12.187 19.5 27.223 0 15.037-8.726 27.224-19.5 27.224Zm45.602-100.164s12.241 4.455 11.421 16.161c6.612-8.167 1.143-17.377-11.421-16.161Z"
  />
);

export default Binoculars;
